module.exports = __webpack_public_path__ + "img/es.4b8ce562.svg";